<ul class="smartbutton p-grid">
  <ng-container #smartButtonsVCR></ng-container>
</ul>
<div [ngStyle]="{ display: isMoreButton ? 'inline-block' : 'none' }" class="tabManage">
  <ul class="smartbuttonMore">
    <li>
      <a href="#" class="icon-more-title" (click)="$event.preventDefault()">
        <i class="icon-menu-more" aria-hidden="true"></i>
      </a>
      <ul>
        <ng-container #smartButtonsMoreVCR></ng-container>
      </ul>
    </li>
  </ul>
</div>
